
import {
    Breadcrumbs,
    Link,
    styled,

} from "@mui/material";
import ImageIcon from '@mui/icons-material/Image';
import RefreshButton from "../../../../../common/components/refresh_button";
import FormContainer from "../../../../../common/components/form_container";
import { BackButton } from "../../../../../common/components/back_button";
import BottomBar from "../../../../../common/components/bottom_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { useAtributosSistemaViewModel } from "../../viewModels/atributos_sistema_view_model";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import MedidorInput from "./components/medidor_input";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export const AtributosSistemaCadastro = () => {

    const viewModel = useAtributosSistemaViewModel();

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row w-full justify-end gap-2">
                            <BackButton onClick={() => viewModel.handlePageBack()} />
                        </div>
                    }
                />
            </PageTopBar>

            <form className="pb-8" onSubmit={viewModel.handleUpdateAtributosSistema}>
                <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                    <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                        <Link underline="hover" color="inherit">
                            Administração
                        </Link>
                    </Breadcrumbs>

                    <div className="flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                        <div className="flex gap-2 items-center w-full">
                            <h1 className="text-3xl font-medium text-black dark:text-white">
                                Parâmetros do Sistema
                            </h1>
                            <RefreshButton onClick={() => viewModel.handleReload()} />
                        </div>
                    </div>


                    <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">

                        <div className="w-full bg-white p-4 rounded-2xl shadow-sm mb-4 dark:bg-dark-mode-3">
                            <div className="gap-4 w-full ">
                                <DefaultFormInput
                                    name='nomeCliente'
                                    label='Nome da Empresa'
                                    required={true}
                                    multiline={false}
                                    reactHookForm={viewModel.hookForm} />
                            </div>
                        </div>

                        <FormContainer title={"Logo"} arrangement="fullRow">
                            <>
                                <div>
                                    <span className="text-white bg-yellow-500 px-2 rounded dark:text-white font-semibold   ">A dimensão máxima recomendada para a imagem é de 300x200 pixels
                                    </span>
                                </div>

                                <div className="w-[19rem] h-[10rem] border border-gray-300 py-2 px-6 cursor-pointer" onClick={() => document.getElementById('logoInput')?.click()}>
                                    <div className="w-full h-full flex items-center justify-center">
                                        {viewModel.atributosSistema && viewModel.atributosSistema.logoCliente && viewModel.atributosSistema.logoCliente.length > 0
                                            ? (
                                                <img
                                                    src={`data:image/*; base64,${viewModel.atributosSistema.logoCliente}`}
                                                    className="w-full h-full object-contain bg-center bg-no-repeat"
                                                    alt="Logo Empresa" />
                                            ) : (
                                                <div className="text-center">
                                                    <ImageIcon className="text-gray-400 text-5xl mb-2" />
                                                    <p className="text-gray-400 text-sm">Clique para adicionar logo</p>
                                                </div>
                                            )}
                                    </div>
                                </div>

                                <input
                                    id="logoInput"
                                    type="file"
                                    hidden
                                    onChange={(e) => viewModel.handleFileChange('logoCliente', 'limparArquivo', e, () => { })}
                                    accept="image/*"
                                />

                                <div className="justify-start">
                                    <div className="w-full flex flex-row justify-start ">
                                        <div className="flex flex-row gap-2">
                                            <div className="w-[100%]">
                                                <PrimaryButton
                                                    component="label"
                                                    id='profileInput'
                                                    size="medium"
                                                    fullWidth={true}
                                                    sx={{ paddingLeft: 4, paddingRight: 4 }}>
                                                    <VisuallyHiddenInput
                                                        type="file"
                                                        id='profileImageInput'
                                                        onChange={(e) => { viewModel.handleFileChange('logoCliente', 'limparArquivo', e, () => { }) }}
                                                        accept=".png,.jpeg,.jpg,.gif,.img"
                                                        multiple={false}
                                                    />
                                                    Selecionar
                                                </PrimaryButton>
                                            </div>
                                            <PrimaryButton
                                                onClick={() => viewModel.handleArquivoDeleteOpenState('limparArquivo', 'logoCliente', true)}
                                                buttonColor='red'>
                                                Excluir
                                            </PrimaryButton>
                                        </div>
                                    </div>
                                </div>
                                <div className="w-full flex flex-col justify-start  gap-3">
                                    <p className="flex-1 text-black dark:text-white "> <span className="bg-red-600 text-white p-1 rounded">Atenção!</span>  São permitidas apenas imagens com extensão .png, .jpeg, .jpg, .gif, .img!</p>
                                </div>
                            </>
                        </FormContainer>


                        <div className="w-full flex flex-col justify-start my-5">
                            <span className="text-black dark:text-white font-semibold mb-2"> Espaço Utilizado do Banco de Dados</span>
                            <hr />
                        </div>
                        <FormContainer title={"Armazenamento"} arrangement="fullRow">
                            <div className="w-full bg-white p-4 rounded-2xl shadow-sm mb-4 dark:bg-dark-mode-3 flex flex-row justify-center">
                                <div className="flex flex-col gap-4 w-full justify-between">
                                    <div className="flex flex-row gap-3">
                                        <MedidorInput
                                            percentualUsado={viewModel.espacoUsadoBd?.percentualUtilizado ?? 0}
                                            percentualDisponivel={viewModel.espacoUsadoBd?.percentualLivre ?? 0}
                                            corUsado="#FF9800"  // opcional
                                            corDisponivel="#2196F3"  // opcional
                                        />
                                    </div>

                                    <div className="flex flex-row gap-3">
                                        <span className="text-black dark:text-white font-semibold ">Espaço Total: </span>
                                        <span className="text-black dark:text-white pr-3">{(viewModel.espacoUsadoBd?.espacoTotalGB ?? "10") + " GB"}</span>
                                    </div>

                                    <div className="flex flex-row gap-3">
                                        <span className="text-black dark:text-white font-semibold ">Espaço Utilizado</span>
                                        <span className="text-black dark:text-white">{(viewModel.espacoUsadoBd?.espacoUtilizadoGB ?? "0,00") + " GB"}</span>
                                    </div>

                                    <div className="flex flex-row gap-3">
                                        <span className="text-black dark:text-white font-semibold ">Espaço Disponível</span>
                                        <span className="text-black dark:text-white">{(viewModel.espacoUsadoBd?.espacoLivreGB ?? "0,00") + " GB"}</span>
                                    </div>
                                </div>
                            </div>
                        </FormContainer>
                    </div>
                </div >

                <BottomBar>
                    <div className="w-full h-full flex justify-between items-center p-4 gap-6">
                        <div>
                            <div>
                                <PrimaryButton
                                    buttonColor="yellow"
                                    onClick={() => viewModel.handleOpenChangeHistory(viewModel.atributosSistema?.idAtributoSistema ?? null, null)}>
                                    <span className="text-xs">
                                        Historico de alterações
                                    </span>
                                </PrimaryButton>
                            </div>

                        </div>

                        <div className="w-full h-full flex justify-end items-center p-4 gap-6">

                            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                                <h1 className="text-sm text-black dark:text-white" onClick={() => viewModel.handlePageBack()}>
                                    Cancelar
                                </h1>
                            </div>

                            <div className="w-40">
                                {viewModel.saving ? (
                                    <PrimaryButton>Salvando...</PrimaryButton>
                                ) : (
                                    <PrimaryButton
                                        type="submit"
                                        startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}
                                    >
                                        Salvar
                                    </PrimaryButton>
                                )}
                            </div>
                        </div>
                    </div>
                </BottomBar>
            </form >


            {/* Delete Imagem */}
            <DeleteDialog
                open={viewModel.openDeleteArquivoModalOpen}
                saving={viewModel.saving}
                onClose={() => viewModel.handleArquivoDeleteOpenState(null, null, false)}
                title={`Você realmente deseja excluir a imagem ?`}
                onDelete={viewModel.handleConfirmarDeletarArquivo}
            />


            <ChangeHistoryModal
                changeHistoryHandler={viewModel.changeHistory}
            />


        </>
    );

};
